import { get, post, postToken, reload, put, deleteRequest } from "../web.request";


export const StoreUserBrowserId = async (payload) => {
  return await post(`/addSubscription`, payload);
}
